import { APP_PLATFORMS } from "../../../../../../../../constants"
import generateShortID from "../../../../../../../../utils"
import {
  ACTION_CLASSES,
  INAPP_LAYOUT_TYPES,
  INITIAL_ONBOARDING_STATE_FOR_CAROUSAL,
  NEW_INITIAL_CONFIG_TYPE,
  NEW_INLINE_LAYOUT_TYPES,
  NEXT_BUTTON_STATE_FOR_CAROUSAL,
  PREV_BUTTON_STATE_FOR_CAROUSAL,
  SKIP_BUTTON_STATE,
  TOOLTIP_LAYOUT_TYPES,
  WIDTH_TYPES,
} from "../../constants"
import {
  ARROW_CONFIG,
  BACKGROUND_OFFSET_CONFIG,
  BORDER_CONFIG,
  BUTTON_CONFIG,
  CLOSE_CONFIG,
  CONSTANT_CONFIGS,
  CONTAINER_CONFIG,
  DESCRIPTION,
  DIM_BACKGROUND_CONFIG,
  DIRECTION_CONFIG,
  DISMISS_ACTIONS_CONFIG,
  MARGIN,
  MEDIA_ICON_CONFIG,
  MEDIA_IMAGE_CONFIG,
  MEDIA_VIDEO_CONFIG,
  NEW_ANIMATION_CONFIG,
  NEW_BUTTONS_CONFIG,
  NEW_BUTTON_CONFIG,
  NEW_INLINE_POSITION_CONFIG,
  PADDING,
  SCROLL_CONFIG,
  SHADOW_CONFIG,
  TARGET_CONFIG,
  TEXT_CONFIG,
  TITLE,
  getRetryAndIntervalKeys,
} from "../common"

export const IMAGE_ENCODED =
  "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"

const actionButtonsConfig = () => {
  return {
    action_buttons_config: [
      {
        color: "#017DFD",
        visibility: 1,
        text_config: {
          ...TEXT_CONFIG,
          text: "My Addresses",
          size: 14,
          style: "bold",
          color: "#FFFFFF",
          font_family: "Roboto",
        },
        borders: {
          radius: 0,
          stroke_color: "#000000",
          stroke_width: 0,
        },
        image:
          "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",
        description_config: {
          text: "Manage your addresses",
          size: 12,
          style: "normal",
          color: "#FFFFFF",
          font_family: "Roboto",
        },
        action_config: { action: "dismiss", activity: "", is_deep_link: false },
        __id: generateShortID(),
      },
      {
        color: "#017DFD",
        visibility: 1,
        text_config: {
          ...TEXT_CONFIG,
          text: "My Orders",
          size: 14,
          style: "bold",
          color: "#FFFFFF",
          font_family: "Roboto",
        },
        borders: {
          radius: 0,
          stroke_color: "#000000",
          stroke_width: 0,
        },
        image:
          "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",
        description_config: {
          text: "View your orders",
          size: 12,
          style: "normal",
          color: "#FFFFFF",
          font_family: "Roboto",
        },
        action_config: { action: "dismiss", activity: "", is_deep_link: false },
        __id: generateShortID(),
      },
    ],
  }
}

const buttonsConfig = () => {
  return {
    ...BUTTON_CONFIG,
    __id: generateShortID(),
  }
}

const DEFAULT_WIDTH_CONFIG = {
  width: 60,
  width_type: WIDTH_TYPES.CUSTOM,
}

export const DEFAULT_ELEMENT_HIGHLIGHTER_CONFIG = {
  highlighter: {
    corner_radius: 0,
    offset_radius: 0,
    shape: "rectangle",
    border: {
      color: "#00ff00",
      width: 4,
      opacity: 1,
    },
    offset: {
      bottom: 0,
      left: 0,
      right: 0,
      top: 0,
    },
  },
}

const DEFAULT_COMMON_CONFIG_WEB = {
  name: "",
  activity: "",
  delay: 1000,
  timeout: 30000,
  find_interval: 2000,
  type: "IN_LINE",
  display_type: "inline",
  action_class: ACTION_CLASSES.TOOLTIP,
  ...CONTAINER_CONFIG,
  ...CONSTANT_CONFIGS,
  title_config: {
    ...TEXT_CONFIG,
    text: "Introducing Live Preview",
    color: "#FFFFFF",
    font_family: "Roboto",
    size: 14,
    style: "bold",
  },
  text_config: {
    ...TEXT_CONFIG,
    text: "Can't describe what you are looking for? Take or upload a photo to find similar items",
    color: "#FFFFFF",
    font_family: "Roboto",
    size: 12,
    style: "normal",
  },
  buttons_config: [
    {
      ...buttonsConfig(),
      color: "#",
      text_config: {
        ...TEXT_CONFIG,
        text: "Cancel",
        color: "#FFFFFF",
        font_family: "Roboto",
        size: 12,
        style: "bold",
      },
    },
    {
      ...buttonsConfig(),
      color: "#FFFFFF",
      text_config: {
        ...TEXT_CONFIG,
        text: "Got It",
        color: "#017DFD",
        font_family: "Roboto",
        size: 12,
        style: "bold",
      },
      borders: {
        radius: 4,
        stroke_color: "#000000",
        stroke_width: 0,
      },
    },
  ],
}

const DEFAULT_COMMON_CONFIG_ANDROID = {
  name: "",
  activity: "",
  delay: 1000,
  timeout: 30000,
  find_interval: 2000,
  type: "IN_LINE",
  display_type: "inline",
  action_class: ACTION_CLASSES.TOOLTIP,
  ...CLOSE_CONFIG,
  ...CONTAINER_CONFIG,
  ...CONSTANT_CONFIGS,
  ...DEFAULT_WIDTH_CONFIG,
  ...DEFAULT_ELEMENT_HIGHLIGHTER_CONFIG,
  title_config: {
    ...TEXT_CONFIG,
    text: "Introducing Live Preview",
    color: "#FFFFFF",
    font_family: "Roboto",
    size: 14,
    style: "bold",
  },
  text_config: {
    ...TEXT_CONFIG,
    text: "Can't describe what you are looking for? Take or upload a photo to find similar items",
    color: "#FFFFFF",
    font_family: "Roboto",
    size: 12,
    style: "normal",
  },
  buttons_config: [
    {
      ...buttonsConfig(),
      color: "#",
      text_config: {
        ...TEXT_CONFIG,
        text: "Cancel",
        color: "#FFFFFF",
        font_family: "Roboto",
        size: 12,
        style: "bold",
      },
    },
    {
      ...buttonsConfig(),
      color: "#FFFFFF",
      text_config: {
        ...TEXT_CONFIG,
        text: "Got It",
        color: "#017DFD",
        font_family: "Roboto",
        size: 12,
        style: "bold",
      },
      borders: {
        radius: 4,
        stroke_color: "#000000",
        stroke_width: 0,
      },
    },
  ],
}

const DEFAULT_COMMON_CONFIG_IOS = {
  name: "",
  activity: "",
  delay: 1000,
  timeout: 30000,
  find_interval: 2000,
  type: "IN_LINE",
  display_type: "inline",
  action_class: ACTION_CLASSES.TOOLTIP,
  ...CLOSE_CONFIG,
  ...CONTAINER_CONFIG,
  ...CONSTANT_CONFIGS,
  ...DEFAULT_WIDTH_CONFIG,
  ...DEFAULT_ELEMENT_HIGHLIGHTER_CONFIG,
  title_config: {
    ...TEXT_CONFIG,
    text: "Introducing Live Preview",
    color: "#FFFFFF",
    font_family: "Helvetica-Bold",
    size: 14,
    style: "bold",
  },
  text_config: {
    ...TEXT_CONFIG,
    text: "Can't describe what you are looking for? Take or upload a photo to find similar items",
    color: "#FFFFFF",
    font_family: "Helvetica",
    size: 12,
    style: "normal",
  },
  buttons_config: [
    {
      ...buttonsConfig(),
      color: "#",
      text_config: {
        ...TEXT_CONFIG,
        text: "Cancel",
        color: "#FFFFFF",
        font_family: "Helvetica-Bold",
        size: 12,
        style: "normal",
      },
    },
    {
      ...buttonsConfig(),
      color: "#FFFFFF",
      text_config: {
        ...TEXT_CONFIG,
        text: "Got It",
        color: "#017DFD",
        font_family: "Helvetica-Bold",
        size: 12,
        style: "normal",
      },
      borders: {
        radius: 4,
        stroke_color: "#000000",
        stroke_width: 0,
      },
    },
  ],
}

const DEFAULT_TOOLTIP_CONFIG_WEB = {
  ...DEFAULT_COMMON_CONFIG_WEB,
  layout_type: TOOLTIP_LAYOUT_TYPES.DEFAULT,
}

const DEFAULT_TOOLTIP_CONFIG_ANDROID = {
  ...DEFAULT_COMMON_CONFIG_ANDROID,
  layout_type: TOOLTIP_LAYOUT_TYPES.DEFAULT,
  dismiss_on_overlap: false,
}

const DEFAULT_TOOLTIP_CONFIG_IOS = {
  ...DEFAULT_COMMON_CONFIG_IOS,
  layout_type: TOOLTIP_LAYOUT_TYPES.DEFAULT,
  dismiss_on_overlap: false,
}

const IMAGE_TEXT_BUTTONS_ANDROID = {
  ...DEFAULT_TOOLTIP_CONFIG_ANDROID,
  layout_type: TOOLTIP_LAYOUT_TYPES.IMAGE_TEXT_BUTTONS,
  image: IMAGE_ENCODED,
  image_type: "",
  image_url: "",
}

const IMAGE_TEXT_BUTTONS_IOS = {
  ...DEFAULT_TOOLTIP_CONFIG_IOS,
  layout_type: TOOLTIP_LAYOUT_TYPES.IMAGE_TEXT_BUTTONS,
  image: IMAGE_ENCODED,
  image_type: "",
  image_url: "",
}

const ACTION_BUTTONS_ANDROID = {
  ...DEFAULT_TOOLTIP_CONFIG_ANDROID,
  ...actionButtonsConfig(),
  buttons_config: [],
  layout_type: TOOLTIP_LAYOUT_TYPES.ACTION_BUTTONS,
}

const DEFAULT_NEW_INLINE_CONFIG = {
  delay: 0,
  type: "IN_LINE",
  action_class: ACTION_CLASSES.INLINE,
  layout_type: INAPP_LAYOUT_TYPES.MODAL,
  display_type: "new-inline",
  ...ARROW_CONFIG,
  arrow: {
    ...ARROW_CONFIG.arrow,
    color: "#017DFD",
  },
  ...NEW_ANIMATION_CONFIG,
  width: 45,
  bg_color: "#017DFD",
  dismiss_outside_touch: true,
  ...PADDING,
  padding: {
    ...PADDING.padding,
    top: 16,
    bottom: 16,
    left: 16,
    right: 16,
  },
  ...MARGIN,
  ...DIM_BACKGROUND_CONFIG,
  dimbackground: {
    ...DIM_BACKGROUND_CONFIG.dimbackground,
    opacity: 0.6,
  },
  ...BACKGROUND_OFFSET_CONFIG,
  ...BORDER_CONFIG,
  border: {
    ...BORDER_CONFIG.border,
    width: 0,
    color: "#FFFFFF",
    radius: 4,
  },
  ...TITLE,
  ...DESCRIPTION,
  ...DIRECTION_CONFIG,
  ...NEW_BUTTONS_CONFIG,
  buttons: {
    ...NEW_BUTTONS_CONFIG.buttons,
    bottom: [
      {
        __id: generateShortID(),
        ...NEW_BUTTON_CONFIG,
        margin: {
          ...MARGIN.margin,
          right: 10,
        },
        slot: 4,
        text: {
          ...NEW_BUTTON_CONFIG.text,
          text: "Cancel",
          font: {
            ...NEW_BUTTON_CONFIG.text.font,
            weight: "bold",
          },
        },
      },
      {
        __id: generateShortID(),
        ...NEW_BUTTON_CONFIG,
        color: "#FFFFFF",
        slot: 5,
        text: {
          ...NEW_BUTTON_CONFIG.text,
          text: "Confirm",
          color: "#017DFD",
          font: {
            ...NEW_BUTTON_CONFIG.text.font,
            weight: "bold",
          },
        },
      },
    ],
  },
  ...CLOSE_CONFIG,
  close_button: {
    ...CLOSE_CONFIG.close_button,
    fill_color: "#017DFD",
  },
  ...SCROLL_CONFIG,
  ...SHADOW_CONFIG,
  ...MEDIA_ICON_CONFIG,
  ...MEDIA_IMAGE_CONFIG,
  ...MEDIA_VIDEO_CONFIG,
  ...NEW_INLINE_POSITION_CONFIG,
  ...TARGET_CONFIG,
  ...DISMISS_ACTIONS_CONFIG,

  window_attributes: {},
  html_config: {},
}

const DEFAULT_NEW_INLINE_CONFIG_MWEB = {
  delay: 0,
  type: "IN_LINE",
  action_class: ACTION_CLASSES.INLINE,
  layout_type: INAPP_LAYOUT_TYPES.MODAL,
  display_type: "new-inline",
  ...ARROW_CONFIG,
  arrow: {
    ...ARROW_CONFIG.arrow,
    color: "#017DFD",
  },
  ...NEW_ANIMATION_CONFIG,
  width: 75,
  bg_color: "#017DFD",
  dismiss_outside_touch: true,
  ...PADDING,
  padding: {
    ...PADDING.padding,
    top: 12,
    bottom: 12,
    left: 12,
    right: 12,
  },
  ...MARGIN,
  ...DIM_BACKGROUND_CONFIG,
  ...BACKGROUND_OFFSET_CONFIG,
  ...BORDER_CONFIG,
  border: {
    ...BORDER_CONFIG.border,
    width: 0,
    color: "#581c87",
    radius: 8,
  },
  ...TITLE,
  title: {
    ...TITLE.title,
    text: "Find your brand",
    color: "#ffffff",
    font: {
      ...TITLE.title.font,
      size: 25,
      weight: "bold",
      family: "inherit",
    },
    margin: {
      ...TITLE.title.margin,
      top: 0,
      right: 0,
      bottom: 4,
      left: 0,
    },
  },
  ...DESCRIPTION,
  description: {
    ...DESCRIPTION.description,
    text: "Can't describe what you are looking for?\nTake or upload a photo to find similar items",
    color: "#ffffff",
    font: {
      ...DESCRIPTION.description.font,
      family: "inherit",
      size: 16,
    },
    margin: {
      ...DESCRIPTION.description.margin,
      top: 0,
      right: 0,
      bottom: 16,
      left: 0,
    },
  },
  ...DIRECTION_CONFIG,
  ...NEW_BUTTONS_CONFIG,
  buttons: {
    ...NEW_BUTTONS_CONFIG.buttons,
    bottom: [
      {
        __id: generateShortID(),
        ...NEW_BUTTON_CONFIG,
        margin: {
          ...MARGIN.margin,
          right: 8,
        },
        padding: {
          ...PADDING.padding,
          top: 8,
          right: 14,
          bottom: 8,
          left: 14,
        },
        color: "#",
        slot: 4,
        text: {
          ...NEW_BUTTON_CONFIG.text,
          color: "#ffffff",
          text: "Cancel",
          font: {
            ...NEW_BUTTON_CONFIG.text.font,
            weight: "bold",
          },
          margin: {
            ...MARGIN.margin,
            right: 0,
          },
          padding: {
            ...PADDING.padding,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        enable_border: false,
        border: {
          ...NEW_BUTTON_CONFIG.border,
          radius: 8,
          width: 2,
          color: "#0EA5E9",
        },
      },
      {
        __id: generateShortID(),
        ...NEW_BUTTON_CONFIG,
        action: {
          ...NEW_BUTTON_CONFIG.action,
          type: "dismiss",
        },
        margin: {
          ...MARGIN.margin,
          right: 8,
        },
        padding: {
          ...PADDING.padding,
          top: 8,
          right: 14,
          bottom: 8,
          left: 14,
        },
        color: "#ffffff",
        slot: 5,
        text: {
          ...NEW_BUTTON_CONFIG.text,
          text: "Confirm",
          color: "#017dfd",
          font: {
            ...NEW_BUTTON_CONFIG.text.font,
            weight: "bold",
          },
          margin: {
            ...MARGIN.margin,
            right: 0,
          },
          padding: {
            ...PADDING.padding,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        border: {
          ...NEW_BUTTON_CONFIG.border,
          radius: 8,
          width: 2,
          color: "#0EA5E9",
        },
      },
    ],
  },
  ...CLOSE_CONFIG,
  close_button: {
    ...CLOSE_CONFIG.close_button,
    color: "#ffffff",
    fill_color: "#E5E5E5",
    offset_top: 12,
    offset_right: 12,
    height: 24,
    width: 24,
  },
  ...SCROLL_CONFIG,
  ...SHADOW_CONFIG,
  ...MEDIA_ICON_CONFIG,
  icon: {
    ...MEDIA_ICON_CONFIG.icon,
    height: 72,
    width: 72,
    margin: {
      ...MARGIN.margin,
      top: 0,
      bottom: 6,
      left: 0,
      right: 0,
    },
  },
  ...MEDIA_IMAGE_CONFIG,
  ...MEDIA_VIDEO_CONFIG,
  ...NEW_INLINE_POSITION_CONFIG,
  ...TARGET_CONFIG,
  ...DISMISS_ACTIONS_CONFIG,

  window_attributes: {},
  html_config: {},
}

export const ONBOARDING_CAROUSAL_TYPE = {
  ...CONTAINER_CONFIG,
  animation: {
    ...CONTAINER_CONFIG.animation,
    duration: 150,
  },
  ...CONSTANT_CONFIGS,
  type: "IN_LINE",
  action_class: "tooltip",
  display_type: "inline",
  layout_type: "carousal_buttons",
  name: "",
  activity: "",
  delay: 1000,
  timeout: 30000,
  find_interval: 2000,
  dim_background: true,
  bg_color: "#2072E4",
  opacity: 1,
  text_config: {
    color: "#ffffff",
    size: 12,
    style: "normal",
    font_family: "Roboto",
    text: "Select the match you want to create a team for, join a contest and win more!",
    margins: [16, 0, 16, 5],
    paddings: [0, 0, 0, 0],
  },
  title_config: {
    color: "#ffffff",
    size: 14,
    style: "bold",
    font_family: "Roboto",
    margins: [16, 16, 16, 5],
    paddings: [0, 0, 0, 0],
    text: "Introducing Match Cards",
  },
  prev: PREV_BUTTON_STATE_FOR_CAROUSAL.prev,
  next: NEXT_BUTTON_STATE_FOR_CAROUSAL.next,
  skip: SKIP_BUTTON_STATE.skip,
}

export function getDefaultTooltipConfig({
  layout_type,
  platform = APP_PLATFORMS.android,
  isOnboardingMode = false,
  is_mweb = false,
  subType = "",
}) {
  if (isOnboardingMode) {
    return {
      ...getRetryAndIntervalKeys(platform, false),
      ...ONBOARDING_CAROUSAL_TYPE,
      ...INITIAL_ONBOARDING_STATE_FOR_CAROUSAL,
    }
  } else {
    switch (platform) {
      case APP_PLATFORMS.android: {
        if (layout_type === TOOLTIP_LAYOUT_TYPES.DEFAULT) {
          return {
            ...DEFAULT_TOOLTIP_CONFIG_ANDROID,
            ...getRetryAndIntervalKeys(platform, false),
          }
        } else if (layout_type === TOOLTIP_LAYOUT_TYPES.ACTION_BUTTONS) {
          return {
            ...ACTION_BUTTONS_ANDROID,
            ...getRetryAndIntervalKeys(platform, false),
          }
        } else if (layout_type === TOOLTIP_LAYOUT_TYPES.IMAGE_TEXT_BUTTONS) {
          return {
            ...IMAGE_TEXT_BUTTONS_ANDROID,
            ...getRetryAndIntervalKeys(platform, false),
          }
        } else if (layout_type === NEW_INLINE_LAYOUT_TYPES.INLINE) {
          let defaultJSON = JSON.parse(
            JSON.stringify(DEFAULT_NEW_INLINE_CONFIG),
          )
          let mWebDefaultJSON = JSON.parse(
            JSON.stringify(DEFAULT_NEW_INLINE_CONFIG_MWEB),
          )
          defaultJSON = {
            ...defaultJSON,
            _id: generateShortID(),
          }
          mWebDefaultJSON = {
            ...mWebDefaultJSON,
            _id: generateShortID(),
          }
          if (subType === NEW_INITIAL_CONFIG_TYPE.MOBILE) {
            return {
              ...mWebDefaultJSON,
              width: 85,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.TITLE_ICON) {
            return {
              ...defaultJSON,
              width: 85,
              title: {
                ...defaultJSON.title,
                enable_icon: true,
                icon: {
                  ...defaultJSON.title.icon,
                  height: 60,
                  width: 60,
                },
              },
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.ICON) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_icon: true,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.IMAGE) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_image: true,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.VIDEO) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_video: true,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.SCROLLABLE) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_scroll: true,
              scroll: {
                ...defaultJSON.scroll,
                height: 120,
                enable_border: true,
              },
              description: {
                ...defaultJSON.description,
                text: `Live preview is a feature commonly found in software applications, especially those related to design, development, or editing tasks. Essentially, it provides users with real-time feedback on their changes before finalizing them. When a user makes adjustments to a document, image, website layout, or any other content, the live preview feature instantly updates the display to reflect those changes. This instantaneous feedback allows users to iterate quickly, experiment with different options, and make informed decisions without needing to continuously save or reload their work. Live preview typically works by continuously monitoring the user's actions and dynamically updating the preview interface accordingly, providing a seamless and efficient workflow experience.`,
              },
            }
          }
        }
        break
      }
      case APP_PLATFORMS.ios: {
        if (layout_type === TOOLTIP_LAYOUT_TYPES.DEFAULT) {
          return {
            ...DEFAULT_TOOLTIP_CONFIG_IOS,
            ...getRetryAndIntervalKeys(platform, false),
          }
        } else if (layout_type === TOOLTIP_LAYOUT_TYPES.IMAGE_TEXT_BUTTONS) {
          return {
            ...IMAGE_TEXT_BUTTONS_IOS,
            ...getRetryAndIntervalKeys(platform, false),
          }
        } else if (layout_type === NEW_INLINE_LAYOUT_TYPES.INLINE) {
          let defaultJSON = JSON.parse(
            JSON.stringify(DEFAULT_NEW_INLINE_CONFIG),
          )
          let mWebDefaultJSON = JSON.parse(
            JSON.stringify(DEFAULT_NEW_INLINE_CONFIG_MWEB),
          )
          defaultJSON = {
            ...defaultJSON,
            _id: generateShortID(),
          }
          mWebDefaultJSON = {
            ...mWebDefaultJSON,
            _id: generateShortID(),
          }
          if (subType === NEW_INITIAL_CONFIG_TYPE.MOBILE) {
            return {
              ...mWebDefaultJSON,
              width: 85,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.TITLE_ICON) {
            return {
              ...defaultJSON,
              width: 85,
              title: {
                ...defaultJSON.title,
                enable_icon: true,
                icon: {
                  ...defaultJSON.title.icon,
                  height: 60,
                  width: 60,
                },
              },
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.ICON) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_icon: true,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.IMAGE) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_image: true,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.VIDEO) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_video: true,
            }
          } else if (subType === NEW_INITIAL_CONFIG_TYPE.SCROLLABLE) {
            return {
              ...(is_mweb
                ? {
                    ...mWebDefaultJSON,
                    width: 85,
                  }
                : {
                    ...defaultJSON,
                  }),
              enable_scroll: true,
              scroll: {
                ...defaultJSON.scroll,
                height: 120,
                enable_border: true,
              },
              description: {
                ...defaultJSON.description,
                text: `Live preview is a feature commonly found in software applications, especially those related to design, development, or editing tasks. Essentially, it provides users with real-time feedback on their changes before finalizing them. When a user makes adjustments to a document, image, website layout, or any other content, the live preview feature instantly updates the display to reflect those changes. This instantaneous feedback allows users to iterate quickly, experiment with different options, and make informed decisions without needing to continuously save or reload their work. Live preview typically works by continuously monitoring the user's actions and dynamically updating the preview interface accordingly, providing a seamless and efficient workflow experience.`,
              },
            }
          }
        }
        break
      }
      case APP_PLATFORMS.web: {
        let defaultJSON = JSON.parse(JSON.stringify(DEFAULT_NEW_INLINE_CONFIG))
        let mWebDefaultJSON = JSON.parse(
          JSON.stringify(DEFAULT_NEW_INLINE_CONFIG_MWEB),
        )
        defaultJSON = {
          ...defaultJSON,
          _id: generateShortID(),
        }
        mWebDefaultJSON = {
          ...mWebDefaultJSON,
          _id: generateShortID(),
        }
        if (layout_type === TOOLTIP_LAYOUT_TYPES.DEFAULT) {
          return {
            ...DEFAULT_TOOLTIP_CONFIG_WEB,
            ...getRetryAndIntervalKeys(platform, false),
          }
        }
        if (subType === NEW_INITIAL_CONFIG_TYPE.FEATURE_DISCOVERY) {
          return {
            ...defaultJSON,
            width: 20,
            bg_color: "#0958ce",
            arrow: {
              ...defaultJSON.arrow,
              color: "#0958ce",
            },
            padding: {
              ...defaultJSON.padding,
              top: 8,
              bottom: 8,
              left: 8,
              right: 8,
            },
            enable_dimbackground: true,
            dimbackground: {
              ...defaultJSON.dimbackground,
              opacity: 0.8,
            },
            position: {
              ...defaultJSON.position,
              position: "bottom",
              enable_offset: true,
              offset: {
                ...defaultJSON.position.offset,
                skid: 0,
                distance: 12,
              },
            },
            border: {
              ...defaultJSON.border,
              radius: 12,
            },
            enable_title: false,
            description: {
              ...defaultJSON.description,
              text: "Click here to quickly edit the project category.",
              font: {
                ...defaultJSON.description.font,
                size: 16,
              },
            },
            buttons: {
              ...defaultJSON.buttons,
              bottom: [],
            },
            close_button: {
              ...defaultJSON.close_button,
              height: 24,
              width: 24,
              action: "cancel",
            },
            dim_background: true,
            dimmed_background: true,
            dim_background_color: "#000000",
            dim_background_opacity: 0.8,
            highlighter: {
              corner_radius: 0,
              offset_radius: 0,
              shape: "rectangle",
              border: {
                color: "#0958ce",
                width: 4,
                opacity: 1,
              },
              offset: {
                bottom: "2",
                left: "2",
                right: "2",
                top: "2",
              },
            },
          }
        }
        if (subType === NEW_INITIAL_CONFIG_TYPE.SMALL) {
          return {
            ...defaultJSON,
            width: 30,
          }
        } else if (subType === NEW_INITIAL_CONFIG_TYPE.MOBILE) {
          return {
            ...mWebDefaultJSON,
            width: 85,
          }
        } else if (subType === NEW_INITIAL_CONFIG_TYPE.TITLE_ICON) {
          return {
            ...defaultJSON,
            width: 30,
            title: {
              ...defaultJSON.title,
              enable_icon: true,
              icon: {
                ...defaultJSON.title.icon,
                height: 30,
                width: 30,
              },
            },
          }
        } else if (subType === NEW_INITIAL_CONFIG_TYPE.ICON) {
          return {
            ...(is_mweb
              ? {
                  ...mWebDefaultJSON,
                  width: 85,
                }
              : {
                  ...defaultJSON,
                  width: 30,
                }),
            enable_icon: true,
            icon: {
              ...defaultJSON.icon,
              height: 72,
              width: 72,
            },
          }
        } else if (subType === NEW_INITIAL_CONFIG_TYPE.IMAGE) {
          return {
            ...(is_mweb
              ? {
                  ...mWebDefaultJSON,
                  width: 85,
                }
              : {
                  ...defaultJSON,
                  width: 30,
                }),
            enable_image: true,
          }
        } else if (subType === NEW_INITIAL_CONFIG_TYPE.VIDEO) {
          return {
            ...(is_mweb
              ? {
                  ...mWebDefaultJSON,
                  width: 85,
                }
              : {
                  ...defaultJSON,
                  width: 30,
                }),
            enable_video: true,
          }
        } else if (subType === NEW_INITIAL_CONFIG_TYPE.SCROLLABLE) {
          return {
            ...(is_mweb
              ? {
                  ...mWebDefaultJSON,
                  width: 85,
                }
              : {
                  ...defaultJSON,
                  width: 30,
                }),
            enable_scroll: true,
            scroll: {
              ...defaultJSON.scroll,
              height: 120,
              enable_border: true,
            },
            description: {
              ...defaultJSON.description,
              text: `Live preview is a feature commonly found in software applications, especially those related to design, development, or editing tasks. Essentially, it provides users with real-time feedback on their changes before finalizing them. When a user makes adjustments to a document, image, website layout, or any other content, the live preview feature instantly updates the display to reflect those changes. This instantaneous feedback allows users to iterate quickly, experiment with different options, and make informed decisions without needing to continuously save or reload their work. Live preview typically works by continuously monitoring the user's actions and dynamically updating the preview interface accordingly, providing a seamless and efficient workflow experience.`,
            },
          }
        }
        break
      }
      default:
        return {}
    }
  }
}
